import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Button, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap";

import { getDevicesReport } from "../api";
import { debounce } from "../utils";
import { FileDownloadButton } from "./";

const FilterField = props => (
  <FormGroup className="col-sm-4 ml-auto">
    <InputGroup>
      <InputGroupAddon addonType="prepend">
        <FileDownloadButton
          endpoint={getDevicesReport}
          data={props.getReportData()}
          name={<FontAwesomeIcon icon="file-download" title="Pobierz zestawienie CSV" />}
          fileExtension="csv"
          className="btn-secondary"
          filenamePrefix="urzadzenia"
        />
      </InputGroupAddon>

      <Input type="text" id="filter" name="filter" placeholder="filtr" value={props.filterValue} onChange={props.onFilterChange} />

      <InputGroupAddon addonType="append">
        <Button type="button" className="btn btn-default" title="Wyczyść" onClick={props.clearFilter}><FontAwesomeIcon icon="times" /></Button>  
      </InputGroupAddon>
    </InputGroup>
  </FormGroup>
);

class UserDevicesFilter extends Component {
  state = {
    filterValue: this.props.defaultValue?.filterValue || "",
  };

  componentDidUpdate() {
    if (!this.props.option) {
      this.onChange(this.props.defaultValue);
    }
  }

  onRadioChange = e => {
    const { value } = e.target;

    this.onChange({ option: value, filterValue: this.state.filterValue });
  };

  onFilterChange = e => {
    const { value } = e.target;

    this.setState(() => ({ filterValue: value }), () => this.onChange({ option: this.props.option, filterValue: value }));
  };

  clearFilter = () => {
    this.setState(() => ({ filterValue: this.props.defaultValue?.filterValue || "" }), () => this.onChange({ ...(this.props.defaultValue || {}), option: this.props.option }));
  };

  onChange = debounce(filters => {
    this.props.onChange(filters);
  }, 1000);

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  getReportData = () => {
    const { filterValue } = this.state;
    const { option, kind, userId, clientId } = this.props;

    return {
      kind,
      filter: option,
      clientId,
      userId,
      searchPhrase: filterValue,
    };
  };

  render() {
    const { option, unassignedEntries, assignedEntries, allEntries, canAssignDevices, filterField } = this.props;
    const { filterValue } = this.state;

    if (!canAssignDevices) {
      return (
        <Form onSubmit={this.onSubmit}>
          <Row>
            {filterField && (
              <FilterField filterValue={filterValue} onFilterChange={this.onFilterChange} getReportData={this.getReportData} clearFilter={this.clearFilter} />
            )}
          </Row>
        </Form>
      );
    }

    return (
      <Form onSubmit={this.onSubmit}>
        <Row>
          {unassignedEntries && (
            <FormGroup check inline>
              <div className="custom-radio custom-control">
                <input type="radio" id="unassignedEntries" name="filterOption" value="1" checked={option === "1"} onChange={this.onRadioChange} />{" "}
                <Label for="unassignedEntries">nieprzypisane</Label>
              </div>
            </FormGroup>
          )}

          {assignedEntries && (
            <FormGroup check inline>
              <div className="custom-radio custom-control">
                <input type="radio" id="assignedEntries" name="filterOption" value="2" checked={option === "2"} onChange={this.onRadioChange} />{" "}
                <Label for="assignedEntries">przypisane</Label>
              </div>
            </FormGroup>
          )}

          {allEntries && (
            <FormGroup check inline>
              <div className="custom-radio custom-control">
                <input type="radio" id="allEntries" name="filterOption" value="3" checked={option === "3"} onChange={this.onRadioChange} />{" "}
                <Label for="allEntries">wszystkie</Label>
              </div>
            </FormGroup>
          )}

          {filterField && (
            <FilterField filterValue={filterValue} onFilterChange={this.onFilterChange} getReportData={this.getReportData} clearFilter={this.clearFilter} />
          )}
        </Row>
      </Form>
    )
  };
}

export default UserDevicesFilter;
